import { useState, useCallback, useEffect } from 'react';
import { useGameStore } from '@/store/gameStore';
import { LobbyScreen } from '@/components/LobbyScreen';
import { GameOverScreen } from '@/components/GameOverScreen';
import { GameCanvas } from '@/components/GameCanvas';
import { HowToPlayScreen } from '@/components/HowToPlayScreen';
import { HUD } from '@/components/HUD';
import { trackLooplayView } from '@/looplay';
export function HomePage() {
  const screen = useGameStore((s) => s.screen);
  const [isPaused, setIsPaused] = useState(false);
  useEffect(() => {
    void trackLooplayView();
  }, []);
  const handleTogglePause = useCallback(() => {
    setIsPaused((prev) => !prev);
  }, []);
  return (
    <div className="h-screen w-screen overflow-hidden bg-slate-950 flex items-center justify-center">
      <div className="relative w-full h-full max-w-[400px] max-h-[700px] flex items-center justify-center">
        {screen === 'lobby' && <LobbyScreen />}
        {screen === 'howtoplay' && <HowToPlayScreen />}
        {screen === 'playing' && (
          <div className="relative w-full h-full">
            <GameCanvas onTogglePause={handleTogglePause} />
            <HUD isPaused={isPaused} onTogglePause={handleTogglePause} />
          </div>
        )}
        {screen === 'gameover' && <GameOverScreen />}
      </div>
    </div>
  );
}